import { AIChatController, ControllerHelper, PlaylistUploadDto } from "collaboration-service";
import Editor from "Dummies/TestImpl/TestEditor";
import { Button, ButtonProps, Modal } from "imaginarity-react-ui";
import * as React from "react";
import { useAppSelector } from "services/ApplicationState/ApplicationState";
import { PlaylistEditActions, useDispatchPLE, useSelectorPLE } from "./PlaylistEdit";
type PlaylistAIModalProps = {
    setLoading?: (loading: boolean) => void;
    buttonProps?: Omit<ButtonProps, "onClick">;
};

const PlaylistAIModal = (p: PlaylistAIModalProps) => {
    const { setLoading, buttonProps } = p;
    const playlist = useSelectorPLE(x => x.playlist);
    const dPLE = useDispatchPLE();
    const contentLanguage = useAppSelector(x => x.contentLanguage);
    const [kiModal, setKiModal] = React.useState(false);
    const [text, setText] = React.useState<string>();


    const updateIt = React.useMemo(() => (text: string, lng: string, playlist: PlaylistUploadDto | undefined) => {
        setKiModal(false);
        const l = async () => {
            setLoading?.(true);
            var res = await ControllerHelper.singleCall({ request: { languages: [lng], message: text }, playlist }, AIChatController.Playlist, true);
            if (res)
                dPLE(PlaylistEditActions.setPlaylist(res));
            setLoading?.(false);

        };
        l();
    }, [dPLE, setLoading]);

    return (
        <>
            <Button
                kind={undefined}
                icon="info brain"
                content="KI"
                {...buttonProps}
                onClick={() => setKiModal(true)}
            />
            <Modal active={kiModal} height='full' width='wide' footer={
                <>
                    <Button kind="cancelButton" icon="times" onClick={() => setKiModal(false)} />
                    <Button icon="save" content="do it" onClick={() => updateIt(text ?? "", contentLanguage ?? "en-GB", playlist)} floated="right" />
                </>
            }>
                <Editor
                    value={text ?? ""}
                    onChange={setText}
                    formats={[]}
                    hideToolbar
                />

            </Modal>
        </>

    )

}

export default PlaylistAIModal;